

module.exports = __webpack_require__.stylable.create(
    "ExpandedGoogleCopy1838972967",
    {"classes":{"root":"ExpandedGoogleCopy1838972967__root","CopyToGoogleWrapper":"ExpandedGoogleCopy1838972967__CopyToGoogleWrapper","CopyToGoogle":"ExpandedGoogleCopy1838972967__CopyToGoogle"},"vars":{},"stVars":{"DefaultFont":"\"{theme: 'Body-M', size: '14px', lineHeight: '14px'}\"","EventTitleFont":"\"fallback(font(--eventTitleFont), font({theme: 'Body-M', size: '14px', lineHeight: '14px'}))\"","EventTitleColor":"\"fallback(color(--eventTitleColor), color(color-5))\""},"keyframes":{}},
    "",
    16,
    "ExpandedGoogleCopy1838972967",
    null
);
